import { Inject, Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { EVENT, HistoryEventService } from './history.event.service';
import { AccountService } from './account';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LogService {

  constructor(
  ) {
  }

  public LogRequest(methodType: string, method: string, url: string, requestParams: any) {
    if (environment.isShowConsoleLog) {
      var dateStr = new Date().toLocaleTimeString('de-DE');
      var logStr = '%c';
      logStr = logStr + dateStr + " Request method: " + methodType + " " + method + " url:" + url;
      console.groupCollapsed(logStr, "color:  #82a804ff");
      logStr = dateStr + " params: " + JSON.stringify(requestParams)
      console.log(logStr);
      console.groupEnd();
    }
  }

  public LogResponse(status: string, method: string, url: string, response: any) {
    if (environment.isShowConsoleLog) {
      var dateStr = new Date().toLocaleTimeString('de-DE');
      var logStr = '%c';
      logStr = logStr + dateStr + " Response status: " + status + " " + method + " url: " + url;
      console.groupCollapsed(logStr, "color:  #08a9c5ff");
      logStr = dateStr + " response: " + JSON.stringify(response)
      console.log(logStr);
      console.groupEnd();
    }
  }

  public LogMessage(message: string) {
    if (environment.isShowConsoleLog) {
      var logStr = new Date().toLocaleTimeString('de-DE');
      logStr = logStr + " " + message
      console.log(logStr);
    }
  }

}
